class Role {
  static FARMER = "Farmer";
  static HUNTER = "Hunter";
  static WOODCUTTER = "Woodcutter";
  static SHEPHERD = "Shepherd";
  static EXPLORER = "Explorer";
  static ADVENTURER = "Adventurer";
  static RANGER = "Ranger";

  static startingClass() {
    return new Role(Role.FARMER);
  }

  constructor(title) {
    this.title = title;
  }

  changeTitle(title) {
    this.title = title;

    // Upgrades
    switch (title) {
      case Role.HUNTER:
        this.owner.stats.agility += 4;
      break;

      case Role.SHEPHERD:
        this.owner.stats.strength += 2;
        this.owner.stats.toughness += 2;
      break;

      case Role.WOODCUTTER:
        this.owner.stats.strength += 4;
      break;

      case Role.EXPLORER:
        this.owner.stats.toughness += 4;
      break;
    }
  }
}

export default Role;
